
const formatImage = (url) => url?.replace(/[^?]*$/,'')

export default formatImage